import { supabase } from '@/lib/supabase-client';

export const markAsRead = async (notificationId: string) => {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true })
    .eq('id', notificationId);

  if (error) {
    throw error;
  }
};

export const MarkAllAsRead = async (uid: string) => {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true })
    .eq('user_id', uid);

  if (error) {
    throw error;
  }
};
